var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "py-4 flex",
      class: [`type-${_vm.type}`],
      attrs: { id: `question_${_vm.index + 1}` },
    },
    [
      _c(
        "span",
        {
          staticClass:
            "w-12 py-2 px-4 text-3xl leading-relaxed absolute lg:w-20 lg:py-4 lg:px-6",
          class: {
            "bg-exam-mark-correct": _vm.correct === "correct",
            "bg-exam-mark-wrong": _vm.correct === "wrong",
            "bg-exam-mark-part": _vm.correct === "part",
          },
        },
        [_vm._v(_vm._s(_vm.index + 1))]
      ),
      _c(
        "div",
        {
          class: [
            "min-w-0 py-3 flex-1 lg:pl-20 lg:py-5",
            [_vm.isMobile ? "pl-20" : "pl-14"],
          ],
        },
        [
          [
            _c(
              "div",
              { staticClass: "-ml-20 pl-20 flex items-center gap-x-1" },
              [
                _vm.isCreate || _vm.isCopy
                  ? _c("div", {
                      staticClass:
                        "handleQuestion w-10 h-10 my-5 bg-drag flex justify-center items-center absolute -left-5 box-content cursor-grab transform -translate-y-1",
                    })
                  : _vm._e(),
                _c("GrmTextField", {
                  staticClass: "min-w-0 flex-1 transition",
                  attrs: {
                    placeholder: _vm.isMobile
                      ? _vm.$t("testBank.alert.shortName")
                      : _vm.$t("testBank.alert.name"),
                    disabled: _vm.isView,
                  },
                  model: {
                    value: _vm.question.questionTitle,
                    callback: function ($$v) {
                      _vm.$set(_vm.question, "questionTitle", $$v)
                    },
                    expression: "question.questionTitle",
                  },
                }),
                _vm.testbankObj.examType === "QUIZ"
                  ? _c(
                      "div",
                      { staticClass: "flex items-center gap-x-0.5" },
                      [
                        _c("GrmTextField", {
                          staticClass: "w-20",
                          attrs: {
                            type: "number",
                            placeholder: "1",
                            min: 1,
                            max: 100,
                            disabled: !_vm.isCreate && !_vm.isCopy,
                          },
                          model: {
                            value: _vm.question.questionScore,
                            callback: function ($$v) {
                              _vm.$set(_vm.question, "questionScore", $$v)
                            },
                            expression: "question.questionScore",
                          },
                        }),
                        _c("span", { staticClass: "text-xs" }, [
                          _vm._v(_vm._s(_vm.$t("exam.question.point"))),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.isCreate || _vm.isCopy
                  ? _c(
                      "div",
                      [
                        _c(
                          "GrmBtn",
                          {
                            attrs: { size: "xs", color: "red" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("deleteQuestion", _vm.question)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.delete")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          _c(
            "div",
            { staticClass: "mt-2 flex flex-col gap-y-1 relative" },
            [
              _c(
                "draggable",
                _vm._b(
                  {
                    on: {
                      start: _vm.onDragStart,
                      end: _vm.onDragEnd,
                      update: () => _vm.onDragUpdate(_vm.question.answerList),
                    },
                    model: {
                      value: _vm.question.answerList,
                      callback: function ($$v) {
                        _vm.$set(_vm.question, "answerList", $$v)
                      },
                      expression: "question.answerList",
                    },
                  },
                  "draggable",
                  _vm.dragOptions,
                  false
                ),
                _vm._l(_vm.question.answerList, function (answer, i) {
                  return _c(
                    "div",
                    { key: i, staticClass: "flex items-center gap-x-1" },
                    [
                      _vm.isCreate || _vm.isCopy
                        ? _c("div", {
                            staticClass:
                              "handleAnswer w-10 h-10 bg-drag flex justify-center items-center absolute -left-10 box-content cursor-grab",
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass:
                            "question min-w-0 max-w-max flex-1 rounded py-1 flex gap-x-2",
                          class: [
                            _vm.isEdit ? "items-center" : "items-baseline",
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.selectQuestion($event, answer)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "relative" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "number w-5 h-5 border rounded-full flex justify-center items-center text-sm select-none transition",
                                class: [
                                  (_vm.testbankObj.examType === "QUIZ" &&
                                    answer.correct &&
                                    (_vm.isCreate ||
                                      _vm.isEdit ||
                                      _vm.isCopy)) ||
                                  (_vm.testbankExam.examType === "QUIZ" &&
                                    answer.correct &&
                                    _vm.isView)
                                    ? "border-blue-400 bg-blue-400 text-white"
                                    : "border-gray-800",
                                  {
                                    "pointer-events-none":
                                      (_vm.testbankObj.examType === "SURVEY" &&
                                        _vm.isCreate) ||
                                      (_vm.testbankObj.examType === "SURVEY" &&
                                        _vm.isCopy) ||
                                      _vm.isEdit ||
                                      _vm.isView,
                                  },
                                ],
                              },
                              [_vm._v(_vm._s(i + 1))]
                            ),
                            false
                              ? _c("span", {
                                  staticClass:
                                    "w-5 h-5 bg-exam-check-red block absolute -top-2.5 -left-0.5 pointer-events-none",
                                })
                              : _vm._e(),
                          ]),
                          _c("GrmTextField", {
                            staticClass: "w-60",
                            attrs: {
                              size: "xs",
                              placeholder: _vm.$t("testBank.add.placeholder"),
                              disabled: _vm.isView,
                            },
                            model: {
                              value: answer.answerTitle,
                              callback: function ($$v) {
                                _vm.$set(answer, "answerTitle", $$v)
                              },
                              expression: "answer.answerTitle",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.isCreate || _vm.isCopy
                        ? _c(
                            "GrmBtn",
                            {
                              attrs: { size: "xs", color: "red" },
                              on: {
                                click: function ($event) {
                                  return _vm.onDeleteAnswer(answer)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.delete")))]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                0
              ),
              _vm.isCreate || _vm.isCopy
                ? _c("GrmBtn", { on: { click: _vm.onAddAnswer } }, [
                    _vm._v(_vm._s(_vm.$t("testBank.add.select"))),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }